import { render, staticRenderFns } from "./deliveryDetailUpdate.vue?vue&type=template&id=72f58052&scoped=true"
import script from "./deliveryDetailUpdate.vue?vue&type=script&lang=js"
export * from "./deliveryDetailUpdate.vue?vue&type=script&lang=js"
import style0 from "./deliveryDetailUpdate.vue?vue&type=style&index=0&id=72f58052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f58052",
  null
  
)

export default component.exports